module.exports = __webpack_public_path__ + "static/media/r350.77d59dbb.jpg";